import { useSyncExternalStore } from "react";
import { mediaLibraryStore, IMediaLibraryState } from "../mediaLibraryStore";

export function useMediaLibraryStore<T>(selector: (s: IMediaLibraryState) => T) {
  return useSyncExternalStore(
    mediaLibraryStore.subscribe,
    () => selector(mediaLibraryStore.getState())
  );
}